import { AbstractCommand } from 'src/models/command';

class ShareTheSharedQueryCommand extends AbstractCommand {
	readonly name = 'IFS_Organization_SharedQueries_Command_Command_ShareTheSharedQuery';

	public constructor(sharedQueryId: string, userIdToShareWith: null | number, groupIdToShareWith: null | number) {
		super();
		this.parameters = {
			groupIdToShareWith,
			sharedQueryId,
			userIdToShareWith,
		};
	}
}

export { ShareTheSharedQueryCommand };
